// Cache of the Asset Sets last loaded for a Facility.
//
// Rendering surfaces need the canonical Facility-wide special Asset Sets (All 3D Assets,
// All Asset Tags) to resolve Knowledge View tag visibility. Those rows never appear in the
// Knowledge Book-scoped collection, so this cache has to outlive the Display & Visualization
// session and the 3D/Pano viewer transitions that reset it.
class FacilityAssetSetStore {
    private facilityID: string | null = null;
    private assetSets: readonly IAssetSet[] = [];
    private readonly changeListeners = new Set<() => void>();

    /** Asset Sets for the given Facility, or an empty list when none are cached for it. */
    getAssetSets(facilityID?: string | null): readonly IAssetSet[] {
        if (!this.facilityID) return [];
        if (facilityID && facilityID.toLocaleLowerCase() !== this.facilityID.toLocaleLowerCase()) return [];
        return this.assetSets;
    }

    setAssetSets(facilityID: string, assetSets: readonly IAssetSet[]) {
        if (!facilityID) return;
        this.facilityID = facilityID;
        this.assetSets = assetSets ?? [];
        [...this.changeListeners].forEach(callback => callback());
    }

    addChangeListener(callback: () => void) { this.changeListeners.add(callback); }
    removeChangeListener(callback: () => void) { this.changeListeners.delete(callback); }
}

export default new FacilityAssetSetStore();
